import React from 'react';
import GridContainer from "@/components/common/GridContainer";
import Text from "@/components/common/Text";
import {useStructuredContext} from "@/components/common/StructuredText";

const Paragraph = ({ data, children }) => {
	const isModule = data.children[0].type === 'inlineItem';
	const indent = useStructuredContext('indent')
	const width = useStructuredContext('width')
	//check if paragraph is empty, optional to omit
	// if(children?.[0]?.props?.children?.[0]?.length <= 0) return null

	return !isModule ? (
		<GridContainer className={`indent-desktop-${indent} no-select`}>
			<Text className={`typo-strawford typo-strawford-83 col-mobile-8 col-tablet-8 col-desktop-${width}`}>
				{children}
			</Text>
		</GridContainer>
	) : children
}

export default Paragraph;
